jQuery(function($) {


    /* navigation */
    $(function(){

        var breakpoint = 1200;
        var browser_width = window.innerWidth;
        var htmlbody = $('html, body');
        var burger = $('.burger');
        var navigation = $('.navigation').not('.pagination, .navigation--aux');
        li_has_child = navigation.find('ul li.menu-item-has-children');

        var launch_navigation = function launch_navigation(obj){
            obj.addClass('burger--active');
            htmlbody.addClass('navmenutoggle');
            navigation.addClass('navigation--active');
        };

        var reset_navigation = function reset_navigation(){
            burger.removeClass('burger--active');
            htmlbody.removeClass('navmenutoggle');
            navigation.removeClass('navigation--active');
            navigation.find('ul').removeClass('active');
        };

        $(window).click(function(event){
            if(event.target.className == "navigation navigation--active"){
                reset_navigation();
            };
        });

        burger.click(function(event){
            event.preventDefault();
            if(!htmlbody.hasClass('navmenutoggle')){
                launch_navigation($(this));
            }else{
                reset_navigation();
            };
        });

        var create_li_nav = function create_li_nav(){
            li_has_child.each(function(){
                child_ul = $(this).children('ul');
                child_ul.each(function(){
                    sibling_ahref = $(this).siblings('a').attr('href');
                    sibling_title = $(this).siblings('a').html();
                    $(this).prepend('<li class="menu-item--view"><a href=" ' + sibling_ahref + ' ">View ' + sibling_title +  ' </a></li>');
                    $(this).prepend('<li class="menu-item--back"><a href="#">Back</a></li>');
                });
            });
        };

        var destroy_li_nav = function destroy_li_nav(){
            $('.menu-item--back').remove();
            $('.menu-item--view').remove();
        };


        var modify_menu = function modify_menu(){

            var browser_width = window.innerWidth;
            var back_li = $('.menu-item--back');
            var view_li = $('.menu-item--view');
            var parent_li = $('.navigation__menu > ul > li.menu-item-has-children');
            var child_ul = parent_li.find('ul');
            var child_ul_width = 220;

            var nav_width_checker = function nav_width_checker(){

                sub_menu_total = parseInt(parent_li.length * child_ul_width);

                parent_li.each(function(i){
                    var child_ul_pos = ($(window).width() - ($(this).offset().left + $(this).width()));
                    if(sub_menu_total >= child_ul_pos){
                        $(this).addClass('menu-item-has-children--offsetmenu');
                    }else if(sub_menu_total < child_ul_pos){
                        $(this).removeClass('menu-item-has-children--offsetmenu');
                    };
                });
            };

            var destroy_offset = function destroy_offset(){
                parent_li.removeClass('menu-item-has-children--offsetmenu');
            }

            if(browser_width < breakpoint){
                destroy_offset()
                if(back_li.length < 1 && view_li.length < 1){
                    create_li_nav();
                }
            }else if(browser_width > breakpoint){
                nav_width_checker();
                parent_li.removeClass('offset');
                if(back_li.length > 0 && view_li.length > 0){
                    destroy_li_nav();
                }
            };

            parent_li.find('a').click(function(event){
                var browser_width = window.innerWidth;
                if(browser_width < breakpoint){
                    if($(this).siblings('ul').length > 0){
                        event.preventDefault();
                        $(this).siblings('ul').addClass('active');
                    };
                };
            });

            var back_li = $('.menu-item--back');
            var view_li = $('.menu-item--view');
            back_li.on('click', function(event){
                event.preventDefault();
                $(this).parent('ul').removeClass('active');
            });
            view_li.on('click', function(event){
                event.stopPropagation();
            });
        };

        modify_menu();

        var resizeTimer;
        $(window).on('resize', function(e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                modify_menu();
                reset_navigation();
            }, 250);
        });
    });


});